
  import * as vercelRuntime$DURA3w36tVJ0DkH56wm70Nz4S7WxJbsSJXOSwClr9RY from '/vercel/path0/node_modules/@nuxt/image/dist/runtime/providers/vercel'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "vercel",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['vercel']: { provider: vercelRuntime$DURA3w36tVJ0DkH56wm70Nz4S7WxJbsSJXOSwClr9RY, defaults: {"config":{"minimumCacheTTL":31536000}} }
    }
  }
